import React, { Component } from 'react';
import MobileWalletSection from './MobileWalletSection';
import MobileUserBar from './MobileUserBar';
import Navmenu from './navmenu';
import { withRouter } from './withRouter';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
import { isMobile } from 'react-device-detect';

import Swal from 'sweetalert2';
import Systems from "./SystemFunction";

const bkCss = `
            /* ══ PAGE ══ */
            .bk-chgpass-page{min-height:100vh;background:#f5f6f8;padding-bottom:80px;font-family:'Prompt','Noto Sans Thai',sans-serif;max-width:100vw;overflow-x:hidden;color:#1a1a1a;}
            @media(min-width:769px){.bk-chgpass-page{max-width:480px;margin:0 auto;box-shadow:0 0 24px rgba(0,0,0,0.10);}}

            /* ══ NAVBAR HEADER ══ */
            .mobile-navbar-header{position:sticky;top:0;z-index:150;background:#fff;box-shadow:none!important;border:none!important;border-bottom:none!important;}
            .mobile-nav{display:flex;align-items:center;justify-content:space-between;padding:0 16px;height:56px;width:100%;box-sizing:border-box;border:none!important;box-shadow:none!important;}
            .mobile-nav.header-grey{background:#fff;border:none!important;box-shadow:none!important;}
            .bk-chgpass-page header{border:none!important;box-shadow:none!important;}
            .bk-chgpass-page header *{border-bottom:none!important;}
            .col-left{display:flex;align-items:center;gap:12px;flex:1;min-width:0;}
            .col-right{display:flex;align-items:center;flex-shrink:0;}
            .menu-icon.beta-back{width:22px;height:22px;flex-shrink:0;}
            p.page-title{margin:0;font-size:17px;font-weight:700;color:#1a1a1a;flex:1;}
            .sb-content{position:fixed;top:0;left:-110%;width:75vw;max-width:320px;height:100vh;background:#fff;z-index:600;overflow-y:auto;padding:20px 16px;box-shadow:4px 0 16px rgba(0,0,0,0.18);transition:left .3s ease;box-sizing:border-box;}
            .sb-content.isOpen{left:0;}
            .sb-close-btn{position:absolute;top:12px;right:12px;background:none;border:none;font-size:26px;cursor:pointer;color:#666;padding:4px;line-height:1;}
            .sb-acc-info{display:flex;align-items:center;justify-content:space-between;padding:40px 0 16px;}
            .acc-info{display:flex;align-items:center;gap:10px;flex:1;min-width:0;}
            .sb-leaderboard{display:flex;flex-direction:column;align-items:flex-end;gap:4px;flex-shrink:0;}
            .sb-menu.margin-top{margin-top:8px;}
            .common-menu{border-top:1px solid #f3f4f6;margin-top:16px;padding-top:8px;}
            .sb-content.isOpen::before{content:'';position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.4);z-index:-1;}

            /* ══ WALLET SECTION ══ */
            .member-wallet-links{display:flex;align-items:center;flex-wrap:wrap;gap:0;margin-bottom:6px;}
            .member-wallet-link{font-size:11px;color:#009bd8;cursor:pointer;white-space:nowrap;}
            .member-wallet-sep{color:#ddd;margin:0 5px;font-size:11px;}
            .refresh-btn{background:none;border:none;cursor:pointer;padding:4px;display:flex;align-items:center;color:#009bd8;}
            .refresh-btn svg{width:18px!important;height:18px!important;display:block!important;max-width:18px!important;}
            .action-label{margin:0;font-size:11px;color:#374151;font-weight:500;text-align:center;white-space:nowrap;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .member-action:not(.bottom-content) .action-box svg{width:34px;height:34px;display:block;flex-shrink:0;overflow:visible;}
            .member-action.bottom-content{display:none;flex-wrap:wrap;gap:8px;padding:8px 0 12px;}
            .member-action.bottom-content.show{display:flex!important;}
            .member-action.bottom-content .action-box{width:60px;max-width:60px;}
            .member-action.bottom-content .action-box svg{width:44px;height:44px;display:block;flex-shrink:0;overflow:visible;}
            .message-container{position:relative;display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;}
            .message-container svg{width:44px;height:44px;display:block;}
            .unread-msg{position:absolute;top:-4px;right:-4px;background:#ef4444;color:#fff;font-size:9px;font-weight:700;border-radius:50%;width:16px;height:16px;display:flex;align-items:center;justify-content:center;margin:0;}
            .bk-chgpass-page .collapse{display:flex!important;align-items:center;justify-content:center;gap:6px;padding:8px 0;cursor:pointer;font-size:13px;color:#009bd8;border-top:1px solid #f0f0f0;user-select:none;}
            .bk-chgpass-page .collapse p{margin:0;font-size:13px;color:#009bd8;}
            .bk-chgpass-page .collapse svg{width:8px!important;height:14px!important;pointer-events:none;}
            .slide-arrow .st0{fill:#009bd8;}

     
            /* ══ WALLET SECTION (override) ══ */
            .wallet-info{padding:14px 20px 12px;}
            .top-content{display:flex;align-items:stretch;justify-content:space-between;background:#ffffff;}
            .member-wallet{flex:1;min-width:0;background:#ffffff;display:flex;flex-direction:column;justify-content:space-between;}
            .header{display:flex;align-items:center;justify-content:space-between;}
            .header-left{display:flex;align-items:center;gap:6px;}
            .title{margin:0;font-size:14px;color:#374151;font-weight:500;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .eye-icon{width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;overflow:hidden;}
            .eye-icon svg{width:18px!important;height:18px!important;display:block!important;max-width:18px!important;max-height:18px!important;}
            .bottom{display:flex;align-items:center;gap:8px;padding-top:10px;}
            .member-action:not(.bottom-content){display:flex;gap:4px;padding:0;flex-wrap:nowrap;align-items:stretch;margin-left:8px;}
            .member-action:not(.bottom-content) .action-box{display:flex;flex-direction:column;align-items:center;justify-content:space-between;cursor:pointer;width:56px;max-width:56px;overflow:hidden;padding:2px 0;}
            .member-action:not(.bottom-content) .action-label{margin:0;font-size:11px;color:#374151;font-weight:500;text-align:center;white-space:nowrap;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .currency-label{color:#8b98a5;font-size:13px;margin:0 4px 0 0;font-weight:500;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .member-balance{color:#006bd6;font-size:22px;font-weight:700;margin:0;letter-spacing:-0.3px;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            ._drawerTrigger_19rt2_432{background:none;border:none;cursor:pointer;padding:0;display:flex;align-items:center;}
            ._mainWalletDetails_19rt2_186{margin:0;font-size:12px;color:#009bd8;font-weight:500;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .mobile-beta-refresh{cursor:pointer;display:block;width:20px;height:20px;flex-shrink:0;}
            @keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}

            /* ══ CHANGE PASSWORD CARD ══ */
            .bk-chgpass-hero{margin:18px 20px 0;background:#fff;border-radius:14px;padding:20px 16px;box-shadow:0 1px 8px rgba(0,0,0,.07);}
            .bk-chgpass-hero-title{font-size:16px;font-weight:700;color:#1a1a1a;margin:0 0 4px;}
            .bk-chgpass-hero-sub{font-size:12px;color:#9ca3af;margin:0 0 20px;}
            .bk-chgpass-icon-wrap{width:56px;height:56px;border-radius:50%;background:linear-gradient(135deg,#e8f4ff,#d0eeff);display:flex;align-items:center;justify-content:center;margin:0 auto 16px;}

            /* ══ FORM CARD ══ */
            .bk-form-card{background:#fff;border-radius:12px;margin:10px 20px 0;padding:18px 16px;box-shadow:0 1px 6px rgba(0,0,0,.07);}
            .bk-form-label{font-size:13px;color:#374151;font-weight:600;margin:0 0 8px;display:block;}
            .bk-form-group{margin-bottom:16px;}
            .bk-form-group:last-of-type{margin-bottom:0;}

            /* ══ PASSWORD INPUT WRAPPER ══ */
            .bk-pass-input-wrap{position:relative;display:flex;align-items:center;}
            .bk-pass-input{width:100%;padding:0 44px 0 14px;border:1.5px solid #e5e7eb;border-radius:10px;font-size:15px;color:#1a1a1a;background:#fff;box-sizing:border-box;outline:none;font-family:'Prompt','Noto Sans Thai',sans-serif;height:52px;transition:border-color .15s;}
            .bk-pass-input:focus{border-color:#009bd8;}
            .bk-pass-toggle{position:absolute;right:12px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;padding:4px;display:flex;align-items:center;color:#9ca3af;}
            .bk-pass-toggle:hover{color:#374151;}

            /* ══ INFO BOX ══ */
            .bk-info-box{margin:0 20px 10px;padding:10px 14px;background:#eff6ff;border-radius:10px;font-size:12px;color:#2563eb;border-left:3px solid #009bd8;line-height:1.6;}
            .bk-info-box svg{width:14px!important;height:14px!important;flex-shrink:0;vertical-align:middle;}

            /* ══ SUBMIT BUTTON ══ */
            .bk-submit-btn{width:100%;padding:14px 0;background:linear-gradient(135deg,#ff8a00,#ff5500);color:#fff;border:none;border-radius:12px;font-size:16px;font-weight:700;cursor:pointer;font-family:'Prompt','Noto Sans Thai',sans-serif;margin-top:20px;touch-action:manipulation;transition:opacity .15s;}
            .bk-submit-btn:disabled{background:#d1d5db;cursor:not-allowed;opacity:.7;}

        

            /* ══ MENU CATEGORIES ══ */
            .menu-categories-container{position:fixed;top:0;left:0;right:0;bottom:0;z-index:500;display:flex;justify-content:flex-end;}
            .menu-overlay{position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.45);}
            .menu-account-container{position:relative;width:82vw;max-width:320px;height:100%;background:#fff;overflow-y:auto;box-shadow:-4px 0 20px rgba(0,0,0,0.18);display:flex;flex-direction:column;padding:16px 0 40px;box-sizing:border-box;}
            .menu-account-header{border-bottom:1px solid #f0f2f5;}
            .menu-account-header-title{display:flex;align-items:center;gap:12px;padding:14px 18px;cursor:pointer;user-select:none;}
            .mc-menu-svg{width:32px;height:32px;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
            .menu-account-name{flex:1;font-size:14px;font-weight:600;color:#1a1a1a;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .dropdown-arrow{display:flex;align-items:center;transition:transform .2s;}
            .mc-arrow-open{transform:rotate(180deg);}
            .submenu-account{background:#f8fafc;border-top:1px solid #f0f2f5;}
            .submenu-account-header{padding:12px 18px 12px 62px;font-size:13px;color:#374151;cursor:pointer;font-family:'Prompt','Noto Sans Thai',sans-serif;border-bottom:1px solid #f3f4f6;}
            .submenu-account-header:last-child{border-bottom:none;}
            .mc-sub-active{color:#009bd8;font-weight:600;}
            .mc-badge{font-size:12px;color:#ef4444;font-weight:700;margin-left:4px;}

            /* ══ CHAT BUTTON ══ */
            .bk-chgpass-chat-btn{position:fixed;bottom:76px;right:16px;z-index:300;width:48px;height:48px;border-radius:50%;background:linear-gradient(135deg,#ff8a00,#ff5500);display:flex;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(255,138,0,.45);cursor:pointer;border:none;text-decoration:none;}

            /* ══ SWEETALERT2 COMPACT ══ */
            .swal2-popup{width:300px !important;padding:1.2em 1.4em !important;font-family:'Prompt','Noto Sans Thai',sans-serif !important;}
            .swal2-title{font-size:1.1em !important;padding:0.4em 0 0 !important;}
            .swal2-html-container{font-size:0.85em !important;margin:0.4em 0 0 !important;}
            .swal2-icon{width:56px !important;height:56px !important;margin:0.6em auto 0.4em !important;}
            .swal2-icon .swal2-icon-content{font-size:2em !important;}
            .swal2-actions{margin:0.8em 0 0 !important;gap:8px !important;}
            .swal2-confirm,.swal2-cancel{font-size:0.9em !important;padding:0.55em 1.6em !important;border-radius:8px !important;}
        `;

class App extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loginstate: false,
            username: null,
            token: window.localStorage.getItem('token'),
            userid: null,
            oldpassword: '',
            newpassword: '',
            confirmpassword: '',
            stateopterror: '',
            btnisActive: true,
            linelink: '',
            rankname: null,
            rankpoint: 0,
            balance: 0,
            showOld: false,
            showNew: false,
            showConfirm: false,
            isMenuOpen: false,
            menuOpenIndex: 0,
            isGuideOpen: false,
            showMemberAction: false,
        }
    }

    async componentDidMount() {
        try {
            var token = localStorage.getItem('auth_token');
            if (token != null) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                this.setState({
                    userid: decoded.message.playerid,
                    username: decoded.message.playerid,
                    loginstate: true,
                    token: token,
                });
                await instance.post("/api/v1/checkpoint", {
                    userid: Username,
                    System: Systems,
                    Function: 'componentDidMount-changepassword.js'
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        localStorage.setItem('auth_token', res.data.token);
                        this.setState({
                            balance: res.data.databalance,
                            fullname: res.data.message.firstname,
                            loginstate: true,
                        });
                    } else if (res.data.status === 401) {
                        localStorage.clear();
                        window.location.href = '/';
                    }
                });
            } else {
                this.setState({ loginstate: false });
                window.location.href = '/';
                return;
            }
        } catch (error) {
            console.log(error);
        }
        try {
            await instance.post("/api/v1/mainsetting", {
                System: Systems,
            }).then((res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    this.setState({
                        linelink: datas[1].value,
                    });
                }
            });
        } catch (ex) {
            console.log(ex);
        }
    }

    handleChangePass = async (e) => {
        e.preventDefault();
        const { oldpassword, newpassword, confirmpassword } = this.state;

        if (!oldpassword || oldpassword.trim() === '') {
            await Swal.fire({
                title: 'แจ้งเตือน',
                text: 'กรุณากรอกรหัสผ่านปัจจุบัน',
                icon: 'warning',
                confirmButtonText: 'ตกลง'
            });
            return;
        }
        if (!newpassword || newpassword.trim() === '') {
            await Swal.fire({
                title: 'แจ้งเตือน',
                text: 'กรุณากรอกรหัสผ่านใหม่',
                icon: 'warning',
                confirmButtonText: 'ตกลง'
            });
            return;
        }
        if (newpassword.length < 6) {
            await Swal.fire({
                title: 'แจ้งเตือน',
                text: 'รหัสผ่านใหม่ต้องมีอย่างน้อย 6 ตัวอักษร',
                icon: 'warning',
                confirmButtonText: 'ตกลง'
            });
            return;
        }
        if (newpassword !== confirmpassword) {
            await Swal.fire({
                title: 'แจ้งเตือน',
                text: 'รหัสผ่านใหม่และยืนยันรหัสผ่านไม่ตรงกัน',
                icon: 'warning',
                confirmButtonText: 'ตกลง'
            });
            return;
        }

        this.setState({ btnisActive: false });

        try {
            var token = localStorage.getItem('auth_token');
            if (token == null) {
                await Swal.fire({
                    title: 'แจ้งเตือน',
                    text: 'คุณยังไม่ได้เข้าสู่ระบบ',
                    icon: 'warning',
                    confirmButtonText: 'ตกลง'
                });
                this.setState({ btnisActive: true });
                return;
            }
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;

            await instance.post("/api/v1/resetpassword", {
                username: Username,
                oldpass: oldpassword,
                newpass: newpassword,
                System: Systems,
                type: 1,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    await Swal.fire({
                        title: 'สำเร็จ!',
                        text: 'เปลี่ยนรหัสผ่านเรียบร้อยแล้ว',
                        icon: 'success',
                        confirmButtonText: 'ตกลง'
                    });
                    this.setState({
                        oldpassword: '',
                        newpassword: '',
                        confirmpassword: '',
                        btnisActive: true,
                    });
                } else if (res.data.status === 201) {
                    await Swal.fire({
                        title: 'ผิดพลาด!',
                        text: 'คุณใส่รหัสเก่าผิดพลาด',
                        icon: 'error',
                        confirmButtonText: 'ตกลง'
                    });
                    this.setState({ btnisActive: true });
                } else if (res.data.status === 202) {
                    await Swal.fire({
                        title: 'ผิดพลาด!',
                        text: 'คุณใช้พาสเวิดเดิม',
                        icon: 'error',
                        confirmButtonText: 'ตกลง'
                    });
                    this.setState({ btnisActive: true });
                } else if (res.data.status === 203) {
                    await Swal.fire({
                        title: 'ผิดพลาด!',
                        text: 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง',
                        icon: 'error',
                        confirmButtonText: 'ตกลง'
                    });
                    this.setState({ btnisActive: true });
                } else {
                    await Swal.fire({
                        title: 'ผิดพลาด!',
                        text: 'ไม่สามารถเปลี่ยนรหัสผ่านได้ กรุณาลองใหม่อีกครั้ง',
                        icon: 'error',
                        confirmButtonText: 'ตกลง'
                    });
                    this.setState({ btnisActive: true });
                }
            });
        } catch (err) {
            if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                localStorage.clear();
                await Swal.fire({
                    title: 'Warning!',
                    text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                    icon: 'warning',
                    confirmButtonText: 'ตกลง'
                });
                window.location.href = '/';
            } else {
                await Swal.fire({
                    title: 'ผิดพลาด!',
                    text: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
                this.setState({ btnisActive: true });
            }
        }
    }

    checkurl = (e, url) => {
        e.preventDefault();
        window.location.href = url;
    }

    renderMobile() {
        const {
            username, linelink, rankname, rankpoint, balance,
            oldpassword, newpassword, confirmpassword, btnisActive,
            showOld, showNew, showConfirm,
            loginstate, isMenuOpen, menuOpenIndex, isGuideOpen, showMemberAction
        } = this.state;


        /* ── Eye toggle icon ── */
        const EyeOpen = () => (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
            </svg>
        );
        const EyeClosed = () => (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
                <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
                <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.708zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
            </svg>
        );

        return (
            <>
                <style dangerouslySetInnerHTML={{ __html: bkCss }} />
                <div className="bk-chgpass-page">

                    {/* ══ Mobile Navbar Header ══ */}
                    <header id="mobile-navbar-header" className="mobile-navbar-header">
                        <nav className="mobile-nav header-grey">
                            <div className="col-left">
                                {/* beta-back arrow */}
                                <button
                                    type="button"
                                    onClick={() => this.props.navigate(-1)}
                                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center' }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        viewBox="0 0 22.67717 22.67717"
                                        className="menu-icon beta-back"
                                        width="22" height="22"
                                    >
                                        <defs>
                                            <linearGradient id="cp-back-grad" gradientUnits="userSpaceOnUse" x1="9.094947e-13" y1="11.33858" x2="22.67717" y2="11.33858">
                                                <stop offset="0" style={{ stopColor: "rgb(9,94,189)" }} />
                                                <stop offset="1" style={{ stopColor: "rgb(4,169,194)" }} />
                                            </linearGradient>
                                        </defs>
                                        <path fill="url(#cp-back-grad)" d="M0.3228,12.12548l5.56403,5.54451c0.4294,0.4299,1.12705,0.4299,1.55644,0c0.4304-0.4299,0.4304-1.12705,0-1.55694l-3.68425-3.66523h17.81665c0.60825,0,1.10149-0.49279,1.10149-1.10104c0-0.60825-0.49324-1.10103-1.10149-1.10103H3.75903l3.70018-3.68171c0.4304-0.4299,0.4304-1.12659,0-1.55694C7.24404,4.79186,6.963,4.68475,6.68096,4.68475c-0.28199,0-0.56403,0.10711-0.7782,0.32234L0.3228,10.56803C-0.1076,10.99843-0.1076,11.69513,0.3228,12.12548z" />
                                    </svg>
                                </button>

                                <p className="page-title">เปลี่ยนรหัสผ่าน</p>

                                {/* Sidebar */}
                                <div className={`sb-content ${isGuideOpen ? "isOpen" : ""}`}>
                                    <button
                                        type="button"
                                        className="sb-close-btn"
                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ isGuideOpen: false }); }}
                                    >×</button>
                                    <div className="content-container content-1">
                                        <div className="sb-acc-info">
                                            <div className="acc-info">
                                                <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#f7931a', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 32 32" fill="white">
                                                        <path d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm3.7 14.2c.3-2-1.2-3.1-3.3-3.8l.7-2.7-1.7-.4-.7 2.6-1.3-.3.7-2.6-1.7-.4-.7 2.7-1.1-.3-2.3-.6-.4 1.8s1.2.3 1.2.3c.7.2.8.7.8 1l-.8 3.3c.1 0 .1 0 .2.1l-.2-.1-1.2 4.7c-.1.2-.3.5-.8.4 0 0-1.2-.3-1.2-.3l-.8 2 2.2.5 1.2.3-.7 2.7 1.7.4.7-2.7 1.3.3-.7 2.7 1.7.4.7-2.7c2.8.5 4.9.3 5.8-2.2.7-2-.1-3.1-1.5-3.9 1.1-.3 1.9-1 2.1-2.5zm-3.7 5.2c-.5 2-3.9 1-5 .7l.9-3.5c1.1.3 4.6.9 4.1 2.8zm.5-5.3c-.5 1.8-3.3 1-4.2.7l.8-3.2c.9.2 3.9.7 3.4 2.5z" />
                                                    </svg>
                                                </div>
                                                <div className="info-content" style={{ marginLeft: 10 }}>
                                                    <p style={{ margin: 0, fontSize: 11, color: '#9ca3af' }}>ยินดีต้อนรับ</p>
                                                    <p style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#1a1a1a' }}>{username || '-'}</p>
                                                </div>
                                            </div>
                                            <div className="sb-leaderboard" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                <span style={{ fontSize: 11, background: '#e8f0fe', color: '#1a73e8', borderRadius: 20, padding: '2px 10px', fontWeight: 600 }}>{rankname || 'Normal'}</span>
                                                <span style={{ fontSize: 11, color: '#f59e0b', fontWeight: 600 }}>👑 {rankpoint || 0}</span>
                                            </div>
                                        </div>
                                        <div className="sb-menu margin-top">
                                            {[
                                                { label: 'สปอนเซอร์', href: '/' },
                                                { label: 'VIP', href: '/' },
                                                { label: 'ลีดเดอร์บอร์ด', href: '/' },
                                                { label: 'ดาวน์โหลด', href: '/' },
                                            ].map(item => (
                                                <a key={item.label} href={item.href} style={{ display: 'flex', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f3f4f6', textDecoration: 'none', color: '#374151', fontSize: 14 }}>
                                                    <span>{item.label}</span>
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="common-menu">
                                        {[
                                            { label: 'หน้าแรก', href: '/' },
                                            { label: 'ฝากเงิน', href: '/deposit' },
                                            { label: 'ถอนเงิน', href: '/withdraw' },
                                            { label: 'โปรโมชั่น', href: '/' },
                                            { label: 'กีฬา', href: '/' },
                                            { label: 'อีสปอร์ต', href: '/' },
                                            { label: 'คาสิโนสด', href: '/' },
                                            { label: 'สล็อต', href: '/' },
                                            { label: 'ยิงปลา', href: '/' },
                                            { label: 'ล็อตเตอรี่', href: '/' },
                                            { label: 'เกมด่วน', href: '/' },
                                            { label: 'วงล้อนำโชค', href: '/' },
                                        ].map(item => (
                                            <a key={item.label} href={item.href} style={{ display: 'block', padding: '10px 0', borderBottom: '1px solid #f3f4f6', textDecoration: 'none', color: '#374151', fontSize: 14 }}>
                                                {item.label}
                                            </a>
                                        ))}
                                    </div>
                                    <button
                                        type="button"
                                        style={{ width: '100%', marginTop: 16, padding: '10px 0', background: 'none', border: '1px solid #e5e7eb', borderRadius: 8, color: '#ef4444', fontWeight: 600, cursor: 'pointer', fontSize: 14, fontFamily: 'inherit' }}
                                        onClick={() => { localStorage.clear(); this.props.navigate('/'); }}
                                    >ออกจากระบบ</button>
                                </div>
                            </div>

                            <div className="col-right">
                                {/* 3-dots menu */}
                                <button
                                    type="button"
                                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px 4px', display: 'flex', alignItems: 'center' }}
                                    onClick={() => this.setState({ isMenuOpen: true, menuOpenIndex: 0 })}
                                >
                                    <svg width={27} height={5} viewBox="0 0 27 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#cp-dots-clip)">
                                            <path d="M2.09305 4.66102C3.24901 4.66102 4.1861 3.72393 4.1861 2.56797C4.1861 1.41201 3.24901 0.474915 2.09305 0.474915C0.937091 0.474915 0 1.41201 0 2.56797C0 3.72393 0.937091 4.66102 2.09305 4.66102Z" fill="#8697A2" />
                                            <path d="M13.25 4.66102C14.406 4.66102 15.3431 3.72393 15.3431 2.56797C15.3431 1.41201 14.406 0.474915 13.25 0.474915C12.094 0.474915 11.157 1.41201 11.157 2.56797C11.157 3.72393 12.094 4.66102 13.25 4.66102Z" fill="#8697A2" />
                                            <path d="M24.407 4.66102C25.5629 4.66102 26.5 3.72393 26.5 2.56797C26.5 1.41201 25.5629 0.474915 24.407 0.474915C23.251 0.474915 22.3139 1.41201 22.3139 2.56797C22.3139 3.72393 23.251 4.66102 24.407 4.66102Z" fill="#8697A2" />
                                        </g>
                                        <defs>
                                            <clipPath id="cp-dots-clip">
                                                <rect width="26.5" height="4.19509" fill="white" transform="translate(0 0.474915)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                            </div>
                        </nav>
                    </header>

                    {/* ══ Menu Categories Container (3-dots popup) ══ */}
                    {isMenuOpen && (
                        <div className="menu-categories-container">
                            <div className="menu-overlay" onClick={() => this.setState({ isMenuOpen: false })} />
                            <section className="menu-account-container">
                                {[
                                    { label: 'แคชเชียร์', items: [{ label: 'ฝากเงิน', href: '/deposit' }, { label: 'ถอน', href: '/withdraw' }, { label: 'โอนเงิน', href: '/transfer' }, { label: 'รายละเอียดการถอนเงิน', href: '/withdraw' }] },
                                    { label: 'รางวัล', items: [{ label: 'เงินคืนทันที', href: '/' }, { label: 'งานประจำวัน', href: '/', badge: '1' }, { label: 'แนะนำเพื่อน', href: '/' }] },
                                    { label: 'โปรไฟล์ของฉัน', items: [{ label: 'บัญชีของฉัน', href: '/profile' }, { label: 'ข้อความ', href: '/profile' }, { label: 'เปลี่ยนรหัสผ่าน', href: '/changepassword', active: true }] },
                                    { label: 'ประวัติ', items: [{ label: 'ประวัติการโอนเงิน', href: '/statement' }] },
                                ].map((menu, idx) => (
                                    <div className="menu-account-header" key={idx}>
                                        <div className="menu-account-header-title" onClick={() => this.setState({ menuOpenIndex: menuOpenIndex === idx ? -1 : idx })}>
                                            <div className="mc-menu-svg" style={{ width: 32, height: 32, background: '#f0f4ff', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="#095EBD" viewBox="0 0 16 16">
                                                    <circle cx="8" cy="8" r="7" stroke="#095EBD" strokeWidth="1.5" fill="none" />
                                                    <path d="M8 4v4l3 2" stroke="#095EBD" strokeWidth="1.5" strokeLinecap="round" fill="none" />
                                                </svg>
                                            </div>
                                            <span className="menu-account-name">{menu.label}</span>
                                            <div className={`dropdown-arrow${menuOpenIndex === idx ? ' mc-arrow-open' : ''}`}>
                                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
                                                    <path d="M14.5444 7.10467C14.5444 7.38307 14.4409 7.66252 14.235 7.87536L9.56017 12.7069C9.30038 12.9766 8.95498 13.1228 8.5885 13.1228C8.22093 13.1228 7.87662 12.9744 7.6178 12.7058L2.94304 7.87536C2.53005 7.44963 2.53005 6.75865 2.94304 6.33181C3.35604 5.90502 4.02568 5.90502 4.43759 6.33181L8.5885 10.6219L12.7394 6.33181C13.1523 5.90502 13.821 5.90502 14.235 6.33181C14.4409 6.5447 14.5444 6.82415 14.5444 7.10467Z" fill="#61757E" />
                                                </svg>
                                            </div>
                                        </div>
                                        {menuOpenIndex === idx && (
                                            <div className="submenu-account">
                                                {menu.items.map((item, sidx) => (
                                                    <div
                                                        key={sidx}
                                                        className={`submenu-account-header${item.active ? ' mc-sub-active' : ''}`}
                                                        onClick={() => { this.setState({ isMenuOpen: false }); window.location.href = item.href; }}
                                                    >
                                                        {item.label}{item.badge && <span className="mc-badge">{item.badge}</span>}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}
                                <div style={{ padding: '16px 18px', marginTop: 'auto' }}>
                                    <button
                                        type="button"
                                        style={{ width: '100%', padding: '12px 0', background: 'none', border: '1px solid #e5e7eb', borderRadius: 10, color: '#ef4444', fontWeight: 600, cursor: 'pointer', fontSize: 14, fontFamily: 'inherit' }}
                                        onClick={() => { localStorage.clear(); this.props.navigate('/'); }}
                                    >ออกจากระบบ</button>
                                </div>
                            </section>
                        </div>
                    )}

                    {/* ══ User Top Bar ══ */}
                    <MobileUserBar loginstate={loginstate} username={username} rankname={rankname} rankpoint={rankpoint} />

                    {/* ══ Wallet Section ══ */}
                    <MobileWalletSection
                        loginstate={loginstate}
                        balance={balance}
                        checkcredit={this.state.checkcredit}
                        showMemberAction={this.state.showMemberAction}
                        onRefresh={(e) => this.recheccredit(e)}
                        onToggleMemberAction={() => this.setState({ showMemberAction: !this.state.showMemberAction })}
                        onDeposit={() => this.props.navigate('/deposit')}
                        onWithdraw={() => this.props.navigate('/withdraw')}
                        onStatement={() => this.props.navigate('/statement')}
                        onMessage={() => window.location.href = '/manager/message'}
                    />

                    {/* ══ Info Box ══ */}
                    <div className="bk-info-box" style={{ margin: '14px 20px 0' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" style={{ marginRight: 6, verticalAlign: 'middle' }}>
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                        </svg>
                        <strong>รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร</strong> — กรุณาอย่าแบ่งปันรหัสผ่านกับผู้อื่น
                    </div>

                    {/* ══ Change Password Form Card ══ */}
                    <div className="bk-form-card">
                        {/* Icon */}
                        <div className="bk-chgpass-icon-wrap">
                            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 24 24">
                                <defs>
                                    <linearGradient id="cp-lock-g" x1="2" y1="24" x2="22" y2="0" gradientUnits="userSpaceOnUse">
                                        <stop offset="0" stopColor="#095EBD" />
                                        <stop offset="1" stopColor="#04A9C2" />
                                    </linearGradient>
                                </defs>
                                <rect x="3" y="11" width="18" height="11" rx="2" stroke="url(#cp-lock-g)" strokeWidth="1.8" fill="none" />
                                <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="url(#cp-lock-g)" strokeWidth="1.8" strokeLinecap="round" fill="none" />
                                <circle cx="12" cy="16" r="1.5" fill="url(#cp-lock-g)" />
                            </svg>
                        </div>
                        <p className="bk-chgpass-hero-title" style={{ textAlign: 'center' }}>เปลี่ยนรหัสผ่าน</p>
                        <p className="bk-chgpass-hero-sub" style={{ textAlign: 'center', marginBottom: 24 }}>กรุณากรอกรหัสผ่านปัจจุบันและรหัสผ่านใหม่</p>

                        <form onSubmit={this.handleChangePass}>
                            {/* รหัสผ่านปัจจุบัน */}
                            <div className="bk-form-group">
                                <label className="bk-form-label">
                                    รหัสผ่านปัจจุบัน <span style={{ color: '#ef4444' }}>*</span>
                                </label>
                                <div className="bk-pass-input-wrap">
                                    <input
                                        className="bk-pass-input"
                                        type={showOld ? 'text' : 'password'}
                                        name="oldpassword"
                                        value={oldpassword}
                                        onChange={(e) => this.setState({ oldpassword: e.target.value })}
                                        placeholder="กรอกรหัสผ่านปัจจุบัน"
                                        autoComplete="current-password"
                                    />
                                    <button
                                        type="button"
                                        className="bk-pass-toggle"
                                        onClick={() => this.setState({ showOld: !showOld })}
                                        tabIndex={-1}
                                    >
                                        {showOld ? <EyeOpen /> : <EyeClosed />}
                                    </button>
                                </div>
                            </div>

                            {/* รหัสผ่านใหม่ */}
                            <div className="bk-form-group">
                                <label className="bk-form-label">
                                    รหัสผ่านใหม่ <span style={{ color: '#ef4444' }}>*</span>
                                </label>
                                <div className="bk-pass-input-wrap">
                                    <input
                                        className="bk-pass-input"
                                        type={showNew ? 'text' : 'password'}
                                        name="newpassword"
                                        value={newpassword}
                                        onChange={(e) => this.setState({ newpassword: e.target.value })}
                                        placeholder="กรอกรหัสผ่านใหม่ (อย่างน้อย 6 ตัว)"
                                        autoComplete="new-password"
                                    />
                                    <button
                                        type="button"
                                        className="bk-pass-toggle"
                                        onClick={() => this.setState({ showNew: !showNew })}
                                        tabIndex={-1}
                                    >
                                        {showNew ? <EyeOpen /> : <EyeClosed />}
                                    </button>
                                </div>
                                {/* Password strength hint */}
                                {newpassword.length > 0 && newpassword.length < 6 && (
                                    <p style={{ margin: '4px 0 0', fontSize: 11, color: '#ef4444' }}>รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร</p>
                                )}
                                {newpassword.length >= 6 && (
                                    <p style={{ margin: '4px 0 0', fontSize: 11, color: '#16a34a' }}>✓ ความยาวรหัสผ่านเพียงพอ</p>
                                )}
                            </div>

                            {/* ยืนยันรหัสผ่านใหม่ */}
                            <div className="bk-form-group">
                                <label className="bk-form-label">
                                    ยืนยันรหัสผ่านใหม่ <span style={{ color: '#ef4444' }}>*</span>
                                </label>
                                <div className="bk-pass-input-wrap">
                                    <input
                                        className="bk-pass-input"
                                        type={showConfirm ? 'text' : 'password'}
                                        name="confirmpassword"
                                        value={confirmpassword}
                                        onChange={(e) => this.setState({ confirmpassword: e.target.value })}
                                        placeholder="ยืนยันรหัสผ่านใหม่อีกครั้ง"
                                        autoComplete="new-password"
                                        style={{
                                            borderColor: confirmpassword.length > 0
                                                ? (confirmpassword === newpassword ? '#16a34a' : '#ef4444')
                                                : undefined
                                        }}
                                    />
                                    <button
                                        type="button"
                                        className="bk-pass-toggle"
                                        onClick={() => this.setState({ showConfirm: !showConfirm })}
                                        tabIndex={-1}
                                    >
                                        {showConfirm ? <EyeOpen /> : <EyeClosed />}
                                    </button>
                                </div>
                                {confirmpassword.length > 0 && confirmpassword !== newpassword && (
                                    <p style={{ margin: '4px 0 0', fontSize: 11, color: '#ef4444' }}>รหัสผ่านไม่ตรงกัน</p>
                                )}
                                {confirmpassword.length > 0 && confirmpassword === newpassword && (
                                    <p style={{ margin: '4px 0 0', fontSize: 11, color: '#16a34a' }}>✓ รหัสผ่านตรงกัน</p>
                                )}
                            </div>

                            {/* Submit Button */}
                            <button
                                type="submit"
                                className="bk-submit-btn"
                                disabled={!btnisActive}
                            >
                                {!btnisActive ? (
                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="white" viewBox="0 0 16 16" style={{ animation: 'spin 1s linear infinite' }}>
                                            <path d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                            <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                        </svg>
                                        กำลังดำเนินการ...
                                    </span>
                                ) : 'เปลี่ยนรหัสผ่าน'}
                            </button>
                        </form>
                    </div>

                    {/* ══ Floating Line Chat ══ */}
                    {linelink && (
                        <a href={`https://line.me/ti/p/${linelink}`} target="_blank" rel="noreferrer" className="bk-chgpass-chat-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="#fff" viewBox="0 0 16 16">
                                <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM4.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm-.5 2.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5zm.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3z" />
                            </svg>
                        </a>
                    )}

                    {/* ══ Bottom Navbar ══ */}
                    <Navmenu />

                </div>
            </>
        );
    }

    render() {
        if (isMobile || (typeof window !== 'undefined' && window.innerWidth <= 768)) return this.renderMobile();
        // Desktop fallback — also renders mobile layout (no desktop design)
        return this.renderMobile();
    }
}

export default withRouter(App);
